import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';

import ChatBoxMessageList from './ChatBoxMessageList';
import ChatBoxCompose from './ChatBoxCompose';
import chatActions from '../actions/chat_actions';
import unreadActions from '../actions/unread_message_actions';
import userActions from '../actions/user_actions';
import windowActions from '../actions/window_actions';
import { flashApp } from '../utils/flashNotification';
import { isOn } from '../utils/notificationPreferences';

// One ping covers this much typing, so a fast typist costs no more than a slow
// one: at most one invoke every three seconds per conversation.
const TYPING_PING_MS = 3000;

// How long a received ping keeps the line up. Comfortably longer than the ping
// interval, so an ordinary pause between words never makes it flicker.
const TYPING_EXPIRY_MS = 5000;

// What opening a conversation costs, and what one press of "Load more
// messages..." brings in. These were the window sizes ChatBoxMessageList used
// to page through in memory; api/Channel/GetMessages pages at the source now,
// so the same two numbers are what it asks for. Anything above the endpoint's
// own MaxPageSize (200) is clamped there, quietly.
const INITIAL_PAGE_SIZE = 30;
const OLDER_PAGE_SIZE = 150;

export class ChatBoxTabsWindow extends Component {
    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.button = React.createRef();
        this.state = {
            messages: {},
            chatId: "",
            hub: {},
            channelIdToUserId: {},
            userIdToChannelId: {},
            dateTimeStamp: "",
            tabRecipients: [], // list of tab recipients
            closeIconShown: false,
            closeIconShownIndex: -1,
            currentRecipient: "",
            clickedOnRecipient: {},
            tabIndex: 0,
            currentTabIndex: 0,
            anchorEl: null,
            //setAnchorEl: null,
            flash: true,
            numberOfTabs: 6,
            chatMessageLists: {},
            showMenu: false,
            showDropdownList: false,
            // recipientId -> epoch ms at which their typing line stops being
            // true. A heartbeat rather than a latch: if the pings stop for any
            // reason - they emptied the box, closed the tab, dropped off the
            // network - the deadline passes and tick() takes the line down.
            typingUntil: {},
            // recipientId -> whether the server has history older than what is
            // loaded. Drives whether "Load more messages..." is offered at all,
            // so the reader is never given a press that comes back empty.
            hasMoreMessages: {},
            // recipientId -> an older page is on its way. State rather than an
            // instance field, unlike messagesInFlight below: this one has to
            // render, because it is what disables the button.
            loadingOlder: {},
        };
        // Deliberately not state. Throttling must never cause a render.
        this.lastTypingPingAt = {};
        // recipientId -> true while a GetMessages for them is in flight.
        // render() is what starts that fetch, and state.messages only gains the
        // key once the response lands, so without this every re-render in the
        // gap fires another identical request - and tick() re-renders once a
        // second. Each duplicate re-runs the same unindexed scan and re-downloads
        // the whole history, so the slower the request is the more copies of it
        // pile up. Deliberately not state for the same reason as above: marking
        // a fetch in flight must never itself cause a render.
        this.messagesInFlight = {};
        // channelId -> messages that arrived before that channel was mapped.
        // Only written while a fetch is in flight, so it cannot grow for a
        // conversation nobody is opening.
        this.pendingMessages = {};
    }

    componentDidMount() {

        // Load initial messages
        // this.getChannelMessages(this.props.recipients[0].id); // this needs to be called every time click a tab

        this.setState({ currentRecipient: this.props.recipients[0] });

        // Hub methods
        // state.hub starts as {} and is only replaced once App's connection
        // resolves, so the method has to be there before anything subscribes -
        // without this check a hub that is still connecting throws here and
        // takes the rest of componentDidMount, including the tick interval,
        // with it.
        if (localStorage.getItem("token") !== null && typeof this.props.hub.on === 'function') {
            this.props.hub.on('UserTyping', (notification => {
                var senderId = notification && notification.payload ? notification.payload.userId : null;
                if (!senderId || senderId === this.props.profile.id) {
                    return;
                }
                var deadlines = { ...this.state.typingUntil };
                deadlines[senderId] = Date.now() + TYPING_EXPIRY_MS;
                this.setState({ typingUntil: deadlines });
            }));

            this.props.hub.on('NewMessage', (message => {
                // What they were typing has arrived, so the line has done its
                // job. Drop it now rather than leaving it sitting under their
                // message for the rest of the expiry window.
                this.clearTyping(message.payload.userId);
                var arrived = { 'id': message.payload.id, 'createAt': message.payload.createAt, 'userId': message.payload.userId, 'message': message.payload.message };
                if (this.state.channelIdToUserId.hasOwnProperty(message.payload.channelId)) {
                    var recipientId = this.state.channelIdToUserId[message.payload.channelId];
                    var updatedMessages = [...this.state.messages[recipientId], arrived];
                    var oldMessagesObject = { ...this.state.messages };
                    oldMessagesObject[recipientId] = updatedMessages;
                    this.setState({ 'messages': oldMessagesObject });
                } else if (Object.keys(this.messagesInFlight).length > 0) {
                    // The channel is unmapped and a GetMessages is out, so this
                    // may have been committed after that query read the table.
                    // Hold it for drainPending rather than dropping it. When no
                    // fetch is out the tab simply is not open, and the fetch
                    // MemberList triggers will carry the message anyway.
                    var buffered = this.pendingMessages[message.payload.channelId] || [];
                    buffered.push(arrived);
                    this.pendingMessages[message.payload.channelId] = buffered;
                }
                if (message.payload.userId !== this.props.profile.id) {
                    if (flashApp(this.props.preferences, 'flashstart')) {
                        this.props.setIconFlash(true);
                    }
                }
            }));
        }

        var intervalId = setInterval(this.tick, 1000);
        // store intervalId in the state so it can be accessed later:
        this.setState({ intervalId: intervalId });
        // set chat messages to first recipient
        this.handleTabClick(this.props.recipients[0]);
        this.disableUnread(this.props.recipients[0].id);
        this.props.updateTabIndex(0);
    }

    componentWillUnmount = () => {
        // use intervalId from the state to clear the interval
        clearInterval(this.state.intervalId);
    }

    // Already running every second for the unread-tab flash, so typing lines
    // expire here too rather than on a timer of their own.
    tick = () => {
        var next = { 'flash': !this.state['flash'] };
        var remaining = this.prunedTyping();
        if (remaining !== null) {
            next['typingUntil'] = remaining;
        }
        this.setState(next);
    }

    // Whether an unread tab renders highlighted right now. tick() toggles
    // state.flash every second, so the highlight is the inverse phase.
    //
    // With the preference off this is permanently true rather than
    // permanently false: the tab stops blinking but stays highlighted, so
    // turning the flash off never hides which conversation is waiting.
    showUnreadHighlight = () => {
        if (!isOn(this.props.preferences, 'notifications', 'unreadTabFlash')) {
            return true;
        }
        return !this.state['flash'];
    };

    // A pruned copy when at least one deadline has passed, null when there is
    // nothing to drop - so a second with nobody typing costs no extra work.
    prunedTyping = () => {
        var now = Date.now();
        var remaining = {};
        var changed = false;
        for (var userId in this.state.typingUntil) {
            if (this.state.typingUntil[userId] > now) {
                remaining[userId] = this.state.typingUntil[userId];
            } else {
                changed = true;
            }
        }
        return changed ? remaining : null;
    }

    clearTyping = (userId) => {
        if (!userId || !this.state.typingUntil.hasOwnProperty(userId)) {
            return;
        }
        var remaining = { ...this.state.typingUntil };
        delete remaining[userId];
        this.setState({ typingUntil: remaining });
    }

    // Curried per render the way handleTabClick is, so each compose box knows
    // exactly who it is typing to instead of inferring it from the tab index.
    handleTypingCallback = (recipientId) => () => {
        if (!localStorage.token || typeof this.props.hub.invoke !== 'function') {
            return;
        }
        var now = Date.now();
        var last = this.lastTypingPingAt[recipientId];
        if (last && (now - last) < TYPING_PING_MS) {
            return;
        }
        this.lastTypingPingAt[recipientId] = now;
        // A dropped ping costs one frame of an indicator. Never worth
        // surfacing, and never worth an unhandled rejection.
        this.props.hub.invoke('SendTypingPing', recipientId).catch(() => { });
    }

    // post.id comes along because it is what every merge in here dedupes on.
    // createAt cannot do that job: SendSeveralMessages writes
    // DateTime.Now.Millisecond, so blocks of history share a value in 0-999.
    convertPosts = (posts) => {
        var l = [];
        for (var i = 0; i < posts.length; i++) {
            var post = posts[i];
            l.push({ 'id': post.id, 'createAt': post.createAt, 'userId': post.userId, 'message': post.message });
        }
        return l;
    }

    // One page of a conversation. Both callers share the in-flight guard, so a
    // second press of "Load more messages..." while the first is still out is
    // dropped rather than queued. Resolves to null on any failure - callers
    // leave what is on screen alone rather than blanking it.
    fetchMessagePage = (recipientId, skip, take) => {
        const token = localStorage.token;
        if (!token || this.messagesInFlight[recipientId]) {
            return null;
        }
        this.messagesInFlight[recipientId] = true;
        return fetch("api/Channel/GetMessages", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ 'DisplayName': "", "RecieverId": recipientId, 'Skip': skip, 'Take': take })
        })
            .then(resp => resp.json())
            .then(data => {
                delete this.messagesInFlight[recipientId];
                return data;
            })
            .catch(() => {
                // A failed request must release the slot, or render's guard
                // never fires again for this recipient and the tab stays
                // blank until the window is reopened.
                delete this.messagesInFlight[recipientId];
                return null;
            });
    }

    getChannelMessages = (recipientId) => {
        // console.log("recipientId: ", recipientId);
        var request = this.fetchMessagePage(recipientId, 0, INITIAL_PAGE_SIZE);
        if (!request) {
            return;
        }
        return request.then(data => {
            // console.log("GetChannelMessages data: ", data);
            if (!data) {
                return;
            }
            var newState = { ...this.state };
            newState['channelIdToUserId'][data.channelId] = recipientId;
            newState['userIdToChannelId'][recipientId] = data.channelId;
            var loaded = data.posts ? this.convertPosts(data.posts) : [];
            newState['messages'][recipientId] = loaded.concat(this.drainPending(data.channelId, loaded));
            newState['hasMoreMessages'][recipientId] = !!data.hasMore;
            this.setState(newState);
        });
    }

    // Curried per render the way handleTabClick is, so the button in each tab
    // knows which conversation it is lengthening.
    //
    // Skip is simply how many messages this tab already holds. That works
    // because what it holds is always a contiguous run of the newest posts:
    // the first page is the newest, later pages sit directly below it, and
    // anything arriving live is newer than all of them and gets appended. A
    // message that was persisted but never delivered here (the hub was down)
    // is the one case that puts the offset out by one, which is what the
    // dedupe below is for.
    loadOlderMessages = (recipientId) => () => {
        var held = this.state.messages[recipientId];
        if (!held || !this.state.hasMoreMessages[recipientId]) {
            return;
        }
        var request = this.fetchMessagePage(recipientId, held.length, OLDER_PAGE_SIZE);
        if (!request) {
            return;
        }
        var pending = { ...this.state.loadingOlder };
        pending[recipientId] = true;
        this.setState({ loadingOlder: pending });

        return request.then(data => {
            var settled = { ...this.state.loadingOlder };
            delete settled[recipientId];
            if (!data) {
                // Leave hasMoreMessages alone: the history is still there, the
                // request just failed, so the button stays and can be pressed
                // again.
                this.setState({ loadingOlder: settled });
                return;
            }
            var older = this.convertPosts(data.posts ? data.posts : []);
            var current = this.state.messages[recipientId] || [];
            var newState = { ...this.state };
            newState['messages'][recipientId] = this.mergeOlder(older, current);
            newState['hasMoreMessages'][recipientId] = !!data.hasMore;
            newState['loadingOlder'] = settled;
            this.setState(newState);
        });
    }

    // Older messages go above what is on screen, minus anything already held.
    mergeOlder = (older, current) => {
        return this.withoutHeld(older, current).concat(current);
    }

    // Drops anything from `arriving` whose id is already in `held`. A message
    // with no id is always kept: showing one twice is a blemish, dropping one
    // is data loss, so an id that somehow did not survive the round trip must
    // not be read as "this is the same message".
    withoutHeld = (arriving, held) => {
        var seen = {};
        for (var i = 0; i < held.length; i++) {
            if (held[i].id) {
                seen[held[i].id] = true;
            }
        }
        return arriving.filter(m => !(m.id && seen[m.id]));
    }

    // Messages that arrived while this channel was still unmapped, minus any
    // the response already carried. Without this the single in-flight request
    // above would open a hole the old duplicate-request storm used to paper
    // over: 'NewMessage' can only append once channelIdToUserId knows the
    // channel, and only this fetch teaches it that. SendMessage pushes the
    // notification *before* it commits the row (PostController.cs), so a
    // message racing the query is not a corner case.
    drainPending = (channelId, loaded) => {
        var buffered = this.pendingMessages[channelId];
        delete this.pendingMessages[channelId];
        if (!buffered) {
            return [];
        }
        return this.withoutHeld(buffered, loaded);
    }

    sendMessage = (message, createAt) => {
        const token = localStorage.token;
        if (token) {
            var currentRecipient = this.props.recipients[(this.props.currentTabIndex ? this.props.currentTabIndex : 0)].id;
            var request = JSON.stringify({ 'ChannelId': this.state.userIdToChannelId[currentRecipient], 'Message': message, 'RecieverId': currentRecipient, 'CreateAt': createAt });
            fetch("api/post/SendMessage", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: request
            })
                .then(resp => resp.json())
                .then(data => {
                });
        }
    }

    disableUnreadCallback = () => {
        var currentRecipientId = this.props.recipients[(this.props.currentTabIndex ? this.props.currentTabIndex : 0)].id;
        this.disableUnread(currentRecipientId);
    }

    // appends the new message passed from child ChatBoxCompose
    handleNewMessageCallback = (newMessage) => {
        var currentRecipient = this.props.recipients[(this.props.currentTabIndex ? this.props.currentTabIndex : 0)].id;
        //var newMessages = [...(this.state['messages'][currentRecipient]), newMessage];
        //var newState = { ...this.state['messages'] };
        //newState[currentRecipient] = newMessages;
        // this.setState({ 'messages': newState });
        this.sendMessage(newMessage.message, newMessage.createAt);
    };

    handleTabClick = (recipient, event) => () => {
        //call focusTextInput() in child component
        //console.log("this.refs['textField'].getWrappedInstance(): ", this.refs['textField'].getWrappedInstance());
        //this.refs['textField'].getWrappedInstance().focusTextInput();
        //this.child.myInput.focus();
        if (this.refs['child' + this.props.currentTabIndex] && this.refs['child' + this.props.currentTabIndex].getWrappedInstance()) {
            this.refs['child' + this.props.currentTabIndex].getWrappedInstance().scrollToBottomDelay();
        }
        this.disableUnread(recipient.id);
        this.setState({ clickedOnRecipient: recipient });
    };

    clickAgain = () => {
        if (this.props.recipients.length >= 1) {
            this.refs['child' + this.props.currentTabIndex].getWrappedInstance().scrollToBottom();
        }
    };

    disableUnread = (recipientId) => {
        this.props.updateRead(recipientId);
        // Unconditional, and deliberately so. This was gated on
        // state.shouldTurnFlashOn, but that flag is page memory and the flash
        // lives in the native handler: a reload, the preferences Test button
        // or a double-click on the member list left the handler flashing with
        // the flag false, and from then on reading a message could never stop
        // it. flashstop is idempotent, so send it every time a conversation is
        // read and let the handler ignore a stop for a flash it is not running.
        flashApp(this.props.preferences, 'flashstop');
        this.props.setIconFlash(false);

        if (this.props.profile.hasOwnProperty('id')) { // current signed in user
            this.props.updateLastSeen(false);
            // recipientId is excluded explicitly rather than trusted to have
            // been cleared by the updateRead above. React batches updates inside
            // an event handler, so connect has not re-rendered and
            // this.props.unreadMessages is still the pre-dispatch object with
            // recipientId set. SaveUnreadMessages replaces the caller's whole
            // set, so posting it back re-persisted the conversation that was
            // just read; nothing clears the table at logout, so it came back as
            // a phantom notification at the next login.
            var l = [];
            for (var property in this.props.unreadMessages) {

                if (property.includes("Object")) {
                    continue;
                }
                if (property === recipientId) {
                    continue;
                }
                if (this.props.unreadMessages[property]) {
                    l.push(property);
                }
            }
            this.props.setUnreadIds(l);
        } else {
        }
    };

    handleCloseTab = (recipient) => () => {
        this.props.callbackFromParentRemove(recipient); // pass this recipient to parent MemberList
    };

    showCloseIcon = (index) => () => {
        this.setState({ closeIconShownIndex: index });
    };

    hideCloseIcon = () => {
        this.setState({ closeIconShownIndex: -1 });
    };

    // Opens the dropdown menu.
    handleArrowClick = () => {
        this.setState({ showDropdownList: true });
    };

    // Closes the dropdown menu.
    handleArrowClose = () => {
        this.setState({ showDropdownList: false });
    };

    handleMenuTabChange = (index) => () => {
        this.props.callbackFromParent(this.props.recipients[index], false, false, true);
        // Opening a conversation from the dropdown has to mark it read, the
        // same as clicking its tab does. Without this, the overflow tabs the
        // renderer deliberately flashes (the index >= numberOfTabs branches in
        // render) kept flashing after being opened - and because
        // callbackFromParent moves the recipient to the front, the flash
        // followed them into the selected tab.
        this.disableUnread(this.props.recipients[index].id);
        //console.log("BEFORE IF STATE this.refs['child' + index]", this.refs['child' + index]);
        //console.log("BEFORE IF STATE this.refs['child' + index].getWrappedInstance()", this.refs['child' + index].getWrappedInstance());
        this.setState({}, () => {
            if (this.refs['child' + index] && this.refs['child' + index].getWrappedInstance()) { // this does not get called when index >= 6
                //console.log("this.refs['child' + index]", this.refs['child' + index]);
                //console.log("this.refs['child' + index].getWrappedInstance()", this.refs['child' + index].getWrappedInstance());
                this.refs['child' + index].getWrappedInstance().scrollToBottomDelay();
            }
        });
        this.handleArrowClose();
    };

    render() {

        //const { anchorEl } = this.state;

        let tab = [];
        let tabPanel = [];
        let closeIcon;
        let tabStyle = {};
        let tabListStyle = {};
        //let arrowStyle = { padding: '3px', float: 'right' };
        let awayMessage = "";
        let awayTime = "";
        let awayMessageTime = "";
        let tabName = "";
        let offlineNotification;
        let awayAndOffline;

        let dropdownList =
            <Menu
                id="simple-menu-3"
                anchorEl={this.refs.iconButton}
                keepMounted
                open={this.state.showDropdownList}
                onClose={this.handleArrowClose}
                //style={{ padding: '0px', margin: '0px !important', display: 'grid !important' }}
                MenuListProps={{ style: { padding: '0px', margin: '0px', display: 'grid', height: 'auto' } }}
            >
                {this.props.recipients.map((member, i) => <MenuItem key={i} value={i} onClick={this.handleMenuTabChange(i)} style={{ padding: '0px 5px', fontSize: '13px', minHeight: '25px', overflow: 'hidden', justifyContent: 'left' }}>{member.username}</MenuItem>)}
            </Menu>;

        if (this.props.recipients.length > 0) {
            var index = 0;
            this.props.recipients.forEach((recipientCopy) => {
                var recipient = this.props.memberIdMap[recipientCopy['id']];
                if (!this.state.messages.hasOwnProperty(recipient.id)) {
                    this.getChannelMessages(recipient.id);
                }

                if (this.state.closeIconShownIndex === index) {
                    closeIcon =
                        <IconButton
                            onClick={this.handleCloseTab(recipient)}
                            style={{ padding: '3px' }}
                            size="small"
                        >
                            <CancelIcon style={{ fontSize: '13px' }} />
                        </IconButton>;
                } else {
                    closeIcon = <div></div>;
                }

                // If there is an away message on the recipient object, populate the awayMessage object. Then display it at the bottom under the render.
                if (recipient.awayMessage !== null && recipient.awayMessage !== "") {
                    awayMessage = recipient.awayMessage;
                }
                if (recipient.awayTime !== null && recipient.awayTime !== "") {
                    awayTime = recipient.awayTime;
                }

                // If recipient has away message and is Online, show orange bar in chat window
                if ((recipient.awayMessage !== null && recipient.awayMessage !== "") && (recipient.awayTime !== null && recipient.awayTime !== "") && recipient.status !== "Done") {
                    awayMessageTime =
                        <Grid item xs={12}>
                        <div style={{ textAlign: 'center', backgroundColor: '#ff9400', marginTop: '-10px', position: 'absolute', width: '100%', zIndex: '3' }}>
                                <b>Away message: </b> {awayMessage}<b> - Back by: </b>{awayTime}
                            </div>
                        </Grid>;
                } else {
                    awayMessageTime = <div></div>;
                }

                // If recipient is Offline and does not have away message, show red bar in chat window
                if (recipient.status === "Done" && recipient.inOffice === false && (recipient.awayMessage === "" || recipient.awayMessage === null)) {
                    offlineNotification =
                        <Grid item xs={12}>
                        <div style={{ textAlign: 'center', backgroundColor: '#db6767', marginTop: '-10px', position: 'absolute', width: '100%', zIndex: '3'  }}>
                                <b>User is Offline</b>
                            </div>
                        </Grid>;
                } else {
                    offlineNotification = <div></div>;
                }

                // If recipient has away message AND is Offline, show orange bar and red bar in chat window
                if (recipient.awayMessage !== null && recipient.awayMessage !== "" && recipient.status === "Done" && recipient.inOffice === false) {
                    awayAndOffline =
                        <Grid item xs={12}>
                        <div style={{ textAlign: 'center', backgroundColor: '#db6767', marginTop: '-10px', position: 'absolute', width: '100%', zIndex: '3'  }}>
                                <b>User is Offline</b>
                            </div>
                            <div style={{ textAlign: 'center', backgroundColor: '#ff9400' }}>
                                <b>Away message: </b> {awayMessage}<b> - Back by: </b>{awayTime}
                            </div>
                        </Grid>;
                } else {
                    awayAndOffline = <div></div>;
                }

                if (this.props.unreadMessages[recipient.id] && this.showUnreadHighlight() && index < this.state.numberOfTabs) {
                    tabStyle = { background: '#f7f134', borderRadius: '5px 5px 0px 0px' }; // yellow
                    //tabListStyle = { backgroundColor: '#3f51b5', height: '28px' }; // blue
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                } else if (this.props.unreadMessages[recipient.id] && this.showUnreadHighlight() && index >= this.state.numberOfTabs) {
                    tabStyle = { background: '#f7f134', borderRadius: '5px 5px 0px 0px' }; // yellow
                    //tabListStyle = { backgroundColor: '#3f51b5', height: '28px' }; // blue
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                } else if (this.props.unreadMessages[recipient.id] && !this.showUnreadHighlight() && index >= this.state.numberOfTabs) {
                    tabStyle = { background: '#f6f6f6', borderRadius: '5px 5px 0px 0px' }; // light grey
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                } else if (recipient.status === "Available" && recipient.inOffice === true && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#4dd691', borderRadius: '5px 5px 0px 0px' }; // green
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                } else if (recipient.status === "Busy" && recipient.inOffice === true && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#ff9400', borderRadius: '5px 5px 0px 0px' }; // orange
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                } else if (recipient.status === "Busy" && recipient.inOffice === false && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#ff9400', borderRadius: '5px 5px 0px 0px' }; // orange
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                } else if (recipient.status === "Done" && recipient.inOffice === false && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#dedede', borderRadius: '5px 5px 0px 0px' }; // grey
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                } else if (recipient.status === "Disconnected" && recipient.inOffice === false && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#dedede', borderRadius: '5px 5px 0px 0px' }; // grey
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                } else {
                    tabStyle = { background: '#f6f6f6', borderRadius: '5px 5px 0px 0px' }; // light grey
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                }

                if (index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle['fontWeight'] = 'bold';
                }

                //shortens long names
                var recipientName = recipient.username;
                if (recipient.username.length >= 8) {
                    recipientName = recipientName.slice(0, 8) + "...";
                }
                if (index < this.state.numberOfTabs) {
                    tab.push(
                        <Tab
                            key={recipient.id}
                            onClick={this.handleTabClick(recipient)}
                            onMouseOver={this.showCloseIcon(index)}
                            onMouseLeave={this.hideCloseIcon}
                            style={tabStyle}
                        >
                            {recipientName}
                            {closeIcon}
                        </Tab>
                    );
                    tabPanel.push(
                        <TabPanel key={recipient.id} forceRender={true} onClick={() => this.disableUnread(recipient.id)}>
                            <div onClick={this.props.onClick}>
                                <Grid container spacing={0} style={{}}>
                                    {awayMessageTime}
                                    {offlineNotification}
                                    {awayAndOffline}
                                    <Grid container item xs={12} spacing={0}>
                                        <Grid item xs={12}>
                                            <ChatBoxMessageList callbackFromParentClick={this.clickAgain} recipient={recipient} ref={'child' + index} messages={this.state.messages[recipient.id] ? this.state.messages[recipient.id] : []} typingName={this.state.typingUntil[recipient.id] > Date.now() ? recipient.username : null} hasMore={!!this.state.hasMoreMessages[recipient.id]} loadingOlder={!!this.state.loadingOlder[recipient.id]} onLoadOlder={this.loadOlderMessages(recipient.id)} />
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12} spacing={0} style={{}}>
                                        <ChatBoxCompose ref={(ch) => this.child = ch} messages={this.state.messages[recipient.id] ? this.state.messages[recipient.id] : []} callbackFromParent={this.handleNewMessageCallback} unreadCallback={this.disableUnreadCallback} typingCallback={this.handleTypingCallback(recipient.id)} />
                                    </Grid>
                                </Grid>
                            </div>
                        </TabPanel>
                    );
                }

                index++;
            });
        }

        return (
            <div>
                <Tabs
                    selectedIndex={this.props.currentTabIndex ? this.props.currentTabIndex : 0}
                    onSelect={tabIndex => this.props.updateTabIndex(tabIndex)}
                    // style={{ height: 'auto !important', overflow: 'hidden !important' }}
                >
                    <TabList
                        //style={{ backgroundColor: '#3f51b5', height: '28px' }}
                        style={tabListStyle}
                    >
                        {/*<TabList style={{ backgroundColor: '#f6f6f6', height: '28px' }}>*/}

                        {tab}

                        {/*
                         <IconButton
                            title={'Dropdown'}
                            aria-owns={this.state.anchorEl ? 'simple-menu-3' : undefined}
                            //aria-controls="simple-menu-3"
                            aria-haspopup="true"
                            onClick={this.handleArrowClick}
                            style={{ padding: '3px', float: 'right' }}
                            >
                            <ArrowDropDownIcon style={{ fontSize: '20px' }} />
                        </IconButton>
           
                        <Menu
                            id="simple-menu-3"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={Boolean(this.state.anchorEl)}
                            onClose={this.handleArrowClose}
                            style={{ padding: '0px' }}
                            MenuListProps={{ style: { padding: '0px' } }}
                        >
                            {this.props.recipients.map((member, i) => <MenuItem key={i} value={i} onClick={this.handleMenuTabChange(i)} style={{ padding: '0px 5px', fontSize: '13px', minHeight: '25px' }}>{member.username}</MenuItem>)}
                        </Menu>
                        */}

                        <IconButton
                            title={'Dropdown'}
                            aria-owns={this.state.showDropdownList ? 'simple-menu-3' : undefined}
                            aria-controls="simple-menu-3"
                            aria-haspopup="true"
                            // onClick={this.handleArrowClick} does not work
                            style={{ padding: '3px', float: 'right' }}
                            ref='iconButton'
                            //ref={el => (this.button = el)}
                        >
                            <ArrowDropDownIcon style={{ fontSize: '20px' }} />
                        </IconButton>

                        {this.state.showDropdownList && dropdownList}

                    </TabList>
                    {tabPanel}
                </Tabs>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        hub: state.hub,
        members: state.members,
        profile: state.profile,
        memberIdMap: state.memberIdMap,
        currentUser: state.currentUser,
        unreadMessages: state.unreadMessages,
        currentTabIndex: state.currentTabIndex,
        shouldTurnFlashOn: state.shouldTurnFlashOn,
        preferences: state.preferences,
    };
}

const mapDispatchToProps = dispatch => ({
    updateRead: (userId) => dispatch(userActions['READ_MESSAGE'](userId)),
    updateTabIndex: (tabIndex) => dispatch(chatActions['TAB_INDEX'](tabIndex)),
    setWindowAutoClose: shouldAutoClose => dispatch(windowActions['ALLOW_WINDOW_AUTO_CLOSE'](shouldAutoClose)),
    setUnreadIds: unreadIds => dispatch(unreadActions['SET_UNREAD_IDS'](unreadIds)),
    setIconFlash: shouldTurnFlashOn => dispatch(windowActions['SET_ICON_FLASH'](shouldTurnFlashOn)),
    updateLastSeen: (updateStamp) => dispatch(userActions['UPDATE_LAST_SEEN'](updateStamp))
})

export default connect(mapStateToProps, mapDispatchToProps)(ChatBoxTabsWindow);


// WEBPACK FOOTER //
// ./src/components/ChatBoxTabsWindow.js
/*
export class ChatBoxTabsWindow extends Component {
    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.button = React.createRef();
        this.state = {
            messages: {},
            chatId: "",
            hub: {},
            channelIdToUserId: {},
            userIdToChannelId: {},
            dateTimeStamp: "",
            tabRecipients: [], // list of tab recipients
            closeIconShown: false,
            closeIconShownIndex: -1,
            currentRecipient: "",
            clickedOnRecipient: {},
            tabIndex: 0,
            currentTabIndex: 0,
            anchorEl: null,
            //setAnchorEl: null,
            flash: true,
            numberOfTabs: 6,
            chatMessageLists: {},
            showMenu: false,
            showDropdownList: false,
        };
    }

    flashNotification = (protocol, action, params) => {
        localStorage.setItem("justLoggedIn", true);
        var e = document.createElement('a');
        e.id = 'flashNotification';
        var strParams = "";
        if (typeof params !== 'undefined') {
            Object.keys(params).forEach(function (key) {
                strParams += strParams != "" ? '&' : '';
                strParams += key + '=' + encodeURI(params[key]);
            });
        }
        e.href = strParams.length > 0 ? protocol + '://' + action + '?' + strParams : protocol + '://' + action;
        document.getElementsByTagName('body')[0].appendChild(e);
        e.click();
        e.parentNode.removeChild(e);
    };
    //
    onresize = (e) => {
        this.setState({ windowWidth: e.target.innerWidth }, () => {
            if (this.state.windowWidth < 290) {
                window.open("", "ChatBoxWindow").resizeTo(304, 539);
            }
        });
    };
    /
    //
    unload = () => {
        var chatWindowScreenX = window.open("", "ChatBoxWindow").screenX;
        var chatWindowScreenY = window.open("", "ChatBoxWindow").screenY;
        localStorage.setItem("chatWindowScreenX", chatWindowScreenX);
        localStorage.setItem("chatWindowScreenY", chatWindowScreenY);
    };
    //
    componentDidMount() {
        window.open("", "ChatBoxWindow").addEventListener("resize", this.onresize);

        // Load initial messages
        this.getChannelMessages(this.props.recipients[0].id); // this needs to be called every time click a tab
        this.setState({ currentRecipient: this.props.recipients[0] });

        // Hub methods
        if (localStorage.getItem("token") !== null) {
            this.props.hub.on('NewMessage', (message => {
                if (this.state.channelIdToUserId.hasOwnProperty(message.payload.channelId)) {
                    var recipientId = this.state.channelIdToUserId[message.payload.channelId];
                    var updatedMessages = [...this.state.messages[recipientId], { 'createAt': message.payload.createAt, 'userId': message.payload.userId, 'message': message.payload.message }];
                    var oldMessagesObject = { ...this.state.messages };
                    oldMessagesObject[recipientId] = updatedMessages;
                    this.setState({ 'messages': oldMessagesObject });
                }
                if (message.payload.userId !== this.props.profile.id) {
                    this.flashNotification('teamx', 'flashstart');
                    this.props.setIconFlash(true);
                }
            }));
        }

        var intervalId = setInterval(this.tick, 1000);
        // store intervalId in the state so it can be accessed later:
        this.setState({ intervalId: intervalId });

        // set chat messages to first recipient
        this.handleTabClick(this.props.recipients[0]);
        this.disableUnread(this.props.recipients[0].id);
        this.props.updateTabIndex(0);
        window.open("", "ChatBoxWindow").addEventListener("beforeunload", this.unload);
    }

    componentWillUnmount = () => {
        // use intervalId from the state to clear the interval
        clearInterval(this.state.intervalId);
    }

    tick = () => {
        this.setState({ 'flash': !this.state['flash'] });
    }

    convertPosts = (posts) => {
        var l = [];
        for (var i = 0; i < posts.length; i++) {
            var post = posts[i];
            l.push({ 'createAt': post.createAt, 'userId': post.userId, 'message': post.message });
        }
        return l;
    }

    getChannelMessages = (recipientId) => {
        const token = localStorage.token;
        if (token) {
            return fetch("api/Channel/GetMessages", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ 'DisplayName': "", "RecieverId": recipientId })
            })
                .then(resp => resp.json())
                .then(data => {
                    var newState = { ...this.state };
                    newState['channelIdToUserId'][data.channelId] = recipientId;
                    newState['userIdToChannelId'][recipientId] = data.channelId;
                    newState['messages'][recipientId] = data.posts ? this.convertPosts(data.posts) : [];
                    this.setState(newState);
                });
        }
    }

    sendMessage = (message, createAt) => {
        const token = localStorage.token;
        if (token) {
            var currentRecipient = this.props.recipients[(this.props.currentTabIndex ? this.props.currentTabIndex : 0)].id;
            var request = JSON.stringify({ 'ChannelId': this.state.userIdToChannelId[currentRecipient], 'Message': message, 'RecieverId': currentRecipient, 'CreateAt': createAt });
            fetch("api/post/SendMessage", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: request
            })
            .then(resp => resp.json())
            .then(data => {
            });
        }
    }
    //
    flashNotification = (protocol, action, params) => {
        var e = document.createElement('a');
        e.id = 'flashNotification';
        var strParams = "";
        if (typeof params !== 'undefined') {
            Object.keys(params).forEach(function (key) {
                strParams += strParams != "" ? '&' : '';
                strParams += key + '=' + encodeURI(params[key]);
            });
        }
        e.href = strParams.length > 0 ? protocol + '://' + action + '?' + strParams : protocol + '://' + action;
        document.getElementsByTagName('body')[0].appendChild(e);
        e.click();
        e.parentNode.removeChild(e);
    };
    //

    disableUnreadCallback = () => {
        var currentRecipientId = this.props.recipients[(this.props.currentTabIndex ? this.props.currentTabIndex : 0)].id;
        this.disableUnread(currentRecipientId);
    }

    // appends the new message passed from child ChatBoxCompose
    handleNewMessageCallback = (newMessage) => {
        // var currentRecipient = this.props.recipients[(this.props.currentTabIndex ? this.props.currentTabIndex : 0)].id;
        // var newMessages = [...(this.state['messages'][currentRecipient]), newMessage];
        // var newState = { ...this.state['messages'] };
        // newState[currentRecipient] = newMessages;
        // this.setState({ 'messages': newState });
        this.sendMessage(newMessage.message, newMessage.createAt);
    };

    handleTabClick = (recipient, event) => () => {
        //call focusTextInput() in child component
        //console.log("this.refs['textField'].getWrappedInstance(): ", this.refs['textField'].getWrappedInstance());
        //this.refs['textField'].getWrappedInstance().focusTextInput();
        //this.child.myInput.focus();
        if (this.refs['child' + this.props.currentTabIndex] && this.refs['child' + this.props.currentTabIndex].getWrappedInstance()) {
            // this.refs['child' + this.props.currentTabIndex].getWrappedInstance().scrollToBottomDelay();
        }
        this.disableUnread(recipient.id);
        this.setState({ clickedOnRecipient: recipient });
    };
     
    clickAgain = () => {
        if (this.props.recipients.length >= 1) {
            this.refs['child' + this.props.currentTabIndex].getWrappedInstance().scrollToBottom();
        }
    };

    disableUnread = (recipientId) => {
        this.props.updateRead(recipientId); // updateRead: (userId) => dispatch(userActions['READ_MESSAGE'](userId)),
        if (this.props.shouldTurnFlashOn) {
            this.flashNotification('teamx', 'flashstop');
            this.props.setIconFlash(false);
        }
        if (this.props.profile.hasOwnProperty('id')) { // current signed in user
            this.props.;updateLastSeen(false);
            var l = [];
            for (var property in this.props.unreadMessages) {

                if (property.includes("Object")) {
                    continue;
                }
                if (this.props.unreadMessages[property]) {
                    l.push(property);
                }
            }
            this.props.setUnreadIds(l);
        } else {
        }
        // Stop flash here
        //
        this.flashNotification('teamx', 'flashstop');
        setTimeout(function () {
            this.forceUpdate();
        }.bind(this), 1000);
        //
    };

    handleCloseTab = (recipient) => () => {
        this.props.callbackFromParentRemove(recipient); // pass this recipient to parent MemberList
    };

    showCloseIcon = (index) => () => {
        this.setState({ closeIconShownIndex: index });
    };

    hideCloseIcon = () => {
        this.setState({ closeIconShownIndex: -1 });
    };

    // Opens the dropdown menu.
    handleArrowClick = () => {
        this.setState({ showDropdownList: !this.state.showDropdownList });
    };

    // Closes the dropdown menu.
    handleArrowClose = () => {
        this.setState({ showDropdownList: false });
    };

    handleMenuTabChange = (index) => () => {
        this.props.callbackFromParent(this.props.recipients[index], false, false, true);
        //console.log("BEFORE IF STATE this.refs['child' + index]", this.refs['child' + index]);
        //console.log("BEFORE IF STATE this.refs['child' + index].getWrappedInstance()", this.refs['child' + index].getWrappedInstance());
        this.setState({}, () => {
            if (this.refs['child' + index] && this.refs['child' + index].getWrappedInstance()) { // this does not get called when index >= 6
                //console.log("this.refs['child' + index]", this.refs['child' + index]);
                //console.log("this.refs['child' + index].getWrappedInstance()", this.refs['child' + index].getWrappedInstance());
                this.refs['child' + index].getWrappedInstance().scrollToBottomDelay();
            }
        });
        this.handleArrowClose();
    };

    render() {
        let tab = [];
        let tabPanel = [];
        let closeIcon;
        let tabStyle = {};
        let tabListStyle = {};
        //let arrowStyle = { padding: '3px', float: 'right' };
        let awayMessage = "";
        let awayTime = "";
        let awayMessageTime = "";
        let tabName = "";
        let offlineNotification;
        let awayAndOffline;

        let dropdownList =
            <Menu
                id="simple-menu-3"
                anchorEl={this.refs.iconButton}
                keepMounted
                open={this.state.showDropdownList}
                onClose={this.handleArrowClose}
                //style={{ padding: '0px', margin: '0px !important', display: 'grid !important' }}
                MenuListProps={{ style: { padding: '0px', margin: '0px', display: 'grid' } }}
            >
                {this.props.recipients.map((member, i) => <MenuItem key={i} value={i} onClick={this.handleMenuTabChange(i)} style={{ padding: '0px 5px', fontSize: '13px', minHeight: '25px', justifyContent: 'left' }}>{member.username}</MenuItem>)}
            </Menu>;

        if (this.props.recipients.length > 0) {
            var index = 0;
            this.props.recipients.map((recipientCopy) => {
                var recipient = this.props.memberIdMap[recipientCopy['id']];
                if (!this.state.messages.hasOwnProperty(recipient.id)) {
                    this.getChannelMessages(recipient.id);
                }

                if (this.state.closeIconShownIndex == index) {
                    closeIcon =
                        <IconButton
                            onClick={this.handleCloseTab(recipient)}
                            style={{ padding: '1px', paddingLeft: '8px' }}
                            size="small"
                        >
                            <CancelIcon style={{ fontSize: '13px' }} />
                        </IconButton>;
                } else {
                    closeIcon = <div></div>;
                }

                // If there is an away message on the recipient object, populate the awayMessage object. Then display it at the bottom under the render.
                if (recipient.awayMessage !== null && recipient.awayMessage !== "") {
                    awayMessage = recipient.awayMessage;
                }
                if (recipient.awayTime !== null && recipient.awayTime !== "") {
                    awayTime = recipient.awayTime;
                }

                // If recipient has away message and is Online, show orange bar in chat window
                if ((recipient.awayMessage !== null && recipient.awayMessage !== "") && (recipient.awayTime !== null && recipient.awayTime !== "") && recipient.status !== "Done") {
                    awayMessageTime =
                        <Grid item xs={12}>
                            <div style={{ textAlign: 'center', backgroundColor: '#ff9400', marginTop: '-10px' }}>
                                <b>Away message: </b> {awayMessage}<b> - Back by: </b>{awayTime}
                            </div>
                        </Grid>;
                } else {
                    awayMessageTime = <div></div>;
                }

                // If recipient is Offline and does not have away message, show red bar in chat window
                if (recipient.status === "Done" && recipient.inOffice === false && (recipient.awayMessage === "" || recipient.awayMessage === null)) {
                    offlineNotification =
                        <Grid item xs={12}>
                            <div style={{ textAlign: 'center', backgroundColor: '#db6767', marginTop: '-10px' }}>
                                <b>User is Offline</b>
                            </div>
                        </Grid>;
                } else {
                    offlineNotification = <div></div>;
                }

                // If recipient has away message AND is Offline, show orange bar and red bar in chat window
                if (recipient.awayMessage !== null && recipient.awayMessage !== "" && recipient.status === "Done" && recipient.inOffice === false) {
                    awayAndOffline =
                        <Grid item xs={12}>
                            <div style={{ textAlign: 'center', backgroundColor: '#db6767', marginTop: '-10px' }}>
                                <b>User is Offline</b>
                            </div>
                            <div style={{ textAlign: 'center', backgroundColor: '#ff9400' }}>
                                <b>Away message: </b> {awayMessage}<b> - Back by: </b>{awayTime}
                            </div>
                        </Grid>;
                } else {
                    awayAndOffline = <div></div>;
                }

                if (this.props.unreadMessages[recipient.id] && !this.state['flash'] && index < this.state.numberOfTabs) {
                    tabStyle = { background: '#f7f134', borderRadius: '5px 5px 0px 0px' }; // yellow
                    //tabListStyle = { backgroundColor: '#3f51b5', height: '28px' }; // blue
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                } else if (this.props.unreadMessages[recipient.id] && !this.state['flash'] && index >= this.state.numberOfTabs) {
                    tabStyle = { background: '#f7f134', borderRadius: '5px 5px 0px 0px' }; // yellow
                    //tabListStyle = { backgroundColor: '#3f51b5', height: '28px' }; // blue
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                } else if (this.props.unreadMessages[recipient.id] && this.state['flash'] && index >= this.state.numberOfTabs) {
                    tabStyle = { background: '#f6f6f6', borderRadius: '5px 5px 0px 0px' }; // light grey
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                } else if (recipient.status === "Available" && recipient.inOffice === true && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#4dd691', borderRadius: '5px 5px 0px 0px' }; // green
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                } else if (recipient.status === "Busy" && recipient.inOffice === true && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#ff9400', borderRadius: '5px 5px 0px 0px' }; // orange
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                } else if (recipient.status === "Busy" && recipient.inOffice === false && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#ff9400', borderRadius: '5px 5px 0px 0px' }; // orange
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                } else if (recipient.status === "Done" && recipient.inOffice === false && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#dedede', borderRadius: '5px 5px 0px 0px' }; // grey
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                } else if (recipient.status === "Disconnected" && recipient.inOffice === false && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#dedede', borderRadius: '5px 5px 0px 0px' }; // grey
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                } else {
                    tabStyle = { background: '#f6f6f6', borderRadius: '5px 5px 0px 0px' }; // light grey
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                }

                if (index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle['fontWeight'] = 'bold';
                }

                //shortens long names
                var recipientName = recipient.username;
                if (recipient.username.length > 9) {
                    recipientName = recipientName.slice(0, 8) + "...";
                }

                if (index < this.state.numberOfTabs) {
                    tab.push(
                        <Tab
                            key={recipient.id}
                            onClick={this.handleTabClick(recipient)}
                            onMouseOver={this.showCloseIcon(index)}
                            onMouseLeave={this.hideCloseIcon}
                            style={tabStyle}
                        >
                            {recipient.firstName}
                            {closeIcon}
                        </Tab>
                    );
                    tabPanel.push(
                        <TabPanel key={recipient.id} forceRender={true} onClick={() => this.disableUnread(recipient.id)}>
                            {awayMessageTime}
                            {offlineNotification}
                            {awayAndOffline}
                            <div onClick={this.props.onClick}>
                                <Grid container direction="column" spacing={0} style={{ flexGrow: '1' }}>
                                    <Grid item xs={12} style={{ marginTop: '0px', padding: '0 10px 10px 10px', maxHeight: '275px', maxWidth: '100%', overflowY: 'auto', overflowWrap: 'break-word' }}>
                                        <ChatBoxMessageList callbackFromParentClick={this.clickAgain} recipient={recipient} ref={"child" + index} messages={this.state.messages[recipient.id] ? this.state.messages[recipient.id] : []} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <ChatBoxCompose ref={(ch) => this.child = ch} messages={this.state.messages[recipient.id] ? this.state.messages[recipient.id] : []} callbackFromParent={this.handleNewMessageCallback} unreadCallback={this.disableUnreadCallback}/>
                                    </Grid>
                                </Grid>
                            </div>
                        </TabPanel>
                    );
                }

                index++;
            });
        }
        return (
            <div ref={this.chatBoxFocus}>
                <Tabs
                    selectedIndex={this.props.currentTabIndex ? this.props.currentTabIndex : 0}
                    onSelect={tabIndex => this.props.updateTabIndex(tabIndex)}
                >
                    <TabList style={{ backgroundColor: '#f6f6f6', height: '35px' }}>
                        {tab}
                        <IconButton
                            title={'Dropdown'}
                            aria-owns={this.state.showDropdownList ? 'simple-menu-3' : undefined}
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            onClick={this.handleArrowClick}
                            ref='iconButton'
                            // style={arrowStyle}
                            >
                            <ArrowDropDownIcon style={{ fontSize: '20px' }} />
                        </IconButton>
                        {//this.state.showDropdownList && dropdownList//}
                       
                        <Menu
                            id="simple-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={Boolean(this.state.anchorEl)}
                            onClose={this.handleClose}
                            style={{ padding: '0px' }}
                        >
                            {this.props.recipients.map((member, i) => <MenuItem key={i} value={i} onClick={this.handleMenuTabChange(i)} style={{ padding: '5px 10px', fontSize: '13px' }}>{member.firstName}</MenuItem>)}
                        </Menu>
                        
                    </TabList>
                    {tabPanel}
                </Tabs>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        hub: state.hub,
        members: state.members,
        profile: state.profile,
        memberIdMap: state.memberIdMap,
        currentUser: state.currentUser,
        unreadMessages: state.unreadMessages,
        currentTabIndex: state.currentTabIndex,
        shouldTurnFlashOn: state.shouldTurnFlashOn,
    };
}

const mapDispatchToProps = dispatch => ({
    updateRead: (userId) => dispatch(userActions['READ_MESSAGE'](userId)),
    updateTabIndex: (tabIndex) => dispatch(chatActions['TAB_INDEX'](tabIndex)),
    setWindowAutoClose: shouldAutoClose => dispatch(windowActions['ALLOW_WINDOW_AUTO_CLOSE'](shouldAutoClose)),
    setUnreadIds: unreadIds => dispatch(unreadActions['SET_UNREAD_IDS'](unreadIds)),
    setIconFlash: shouldTurnFlashOn => dispatch(windowActions['SET_ICON_FLASH'](shouldTurnFlashOn)),
    updateLastSeen: (updateStamp) => dispatch(userActions['UPDATE_LAST_SEEN'](updateStamp))
})

export default connect(mapStateToProps, mapDispatchToProps)(ChatBoxTabsWindow);
*/


// WEBPACK FOOTER //
// ./src/components/ChatBoxTabsWindow.js